/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetBadgeContactsQueryVariables = Types.Exact<{
  userId: Types.Scalars["Int"];
}>;

export type GetBadgeContactsQuery = {
  claims: Array<
    Pick<Types.Claim, "id" | "user_id"> & {
      fields_HACKTHENORTH2026_APPLICATIONS: {
        answers: {
          badge_data_json: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value" | "updated_at"
          >;
        };
      };
    }
  >;
};

export const GetBadgeContactsDocument = gql`
  query GetBadgeContacts($userId: Int!) {
    claims(
      take: 1
      where: {
        pipeline: { is: { slug: { equals: "hackthenorth2026-applications" } } }
        user_id: { equals: $userId }
      }
    ) {
      id
      user_id
      fields_HACKTHENORTH2026_APPLICATIONS {
        answers {
          badge_data_json {
            value
            updated_at
          }
        }
      }
    }
  }
`;

/**
 * __useGetBadgeContactsQuery__
 *
 * To run a query within a React component, call `useGetBadgeContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgeContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgeContactsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetBadgeContactsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetBadgeContactsQuery,
    GetBadgeContactsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetBadgeContactsQuery,
    GetBadgeContactsQueryVariables
  >(GetBadgeContactsDocument, baseOptions);
}
export function useGetBadgeContactsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetBadgeContactsQuery,
    GetBadgeContactsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetBadgeContactsQuery,
    GetBadgeContactsQueryVariables
  >(GetBadgeContactsDocument, baseOptions);
}
export type GetBadgeContactsQueryHookResult = ReturnType<
  typeof useGetBadgeContactsQuery
>;
export type GetBadgeContactsLazyQueryHookResult = ReturnType<
  typeof useGetBadgeContactsLazyQuery
>;
export type GetBadgeContactsQueryResult = ApolloReactCommon.QueryResult<
  GetBadgeContactsQuery,
  GetBadgeContactsQueryVariables
>;
